import { memo } from 'react'

import { FilterType } from '@/types/additionalFilters'
import { CardListType } from '@/types/card'

import JumpTo from '../JumpTo/JumpTo'

import ControlsDesktop from './ControlsDesktop'
import ControlsMobile from './ControlsMobile'

type Props = {
  cardLists: CardListType[]
  currentElementIndexInViewport: number
  disabledSortMethods?: string[]
  enableCount?: boolean
  filters: FilterType[]
  groupedBy?: string
  hideControls?: boolean
  hideHeader?: boolean
  loading: boolean
  persist: boolean
  setFilters: (filters: FilterType[]) => void
  sortedBy?: string
  togglePersist: () => void
  updatedAt: number
}

const CardListsHeader = ({
  cardLists,
  currentElementIndexInViewport,
  disabledSortMethods,
  enableCount,
  filters,
  groupedBy,
  hideControls,
  hideHeader,
  // loading,
  persist,
  setFilters,
  sortedBy,
  togglePersist,
  updatedAt,
}: Props) => (
  <>
    <JumpTo
      cardLists={cardLists}
      currentElementIndexInViewport={currentElementIndexInViewport}
      enableCount={enableCount}
      hideHeader={hideHeader}
      updatedAt={updatedAt}
    >
      {hideControls || (
        <ControlsMobile
          disabledSortMethods={disabledSortMethods}
          filters={filters}
          groupedBy={groupedBy}
          persist={persist}
          setFilters={setFilters}
          sortedBy={sortedBy}
          togglePersist={togglePersist}
        />
      )}
    </JumpTo>
    {hideControls || (
      <ControlsDesktop
        // cardLists={cardLists}
        disabledSortMethods={disabledSortMethods}
        filters={filters}
        groupedBy={groupedBy}
        // loading={loading}
        persist={persist}
        setFilters={setFilters}
        sortedBy={sortedBy}
        togglePersist={togglePersist}
      />
    )}
  </>
)

export default memo(CardListsHeader)
